import * as React from "react";
import type { SVGProps } from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
  backgroundFill?: string;
  contentFill?: string;
  enableBorder?: boolean;
}

const SvgWifi = ({
  title = "Wi-Fi",
  titleId = "wifi-icon",
  backgroundFill = "#082ace",
  contentFill = "#fff",
  enableBorder = true,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 204.2 204.2"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    pointerEvents="none"
    {...props}
  >
    <title id={titleId}>{title}</title>
    <g data-name="Layer 1-2">
      <circle
        cx={102.1}
        cy={102.1}
        r={90.3}
        style={{
          fill: backgroundFill,
          strokeWidth: 0,
        }}
      />
      { enableBorder
        && <path
          d="M102.1 0C45.8 0 0 45.8 0 102.1s45.8 102.1 102.1 102.1 102.1-45.8 102.1-102.1S158.4 0 102.1 0Zm90.2 106.6v.4c0 .5 0 1-.1 1.5 0 .4-.1.8-.1 1.2 0 .6-.1 1.2-.2 1.9v.1c0 .5-.1 1-.2 1.5 0 .2 0 .3-.1.5-.1.4-.1.8-.2 1.2v.2c0 .4-.1.7-.2 1v.3c-.1.6-.2 1.1-.3 1.6l-.3 1.8c-.1.4-.2.7-.2 1.1-.1.3-.1.6-.2 1l-.3 1.2c-.1.3-.1.6-.2.8-.1.3-.1.5-.2.8-.2.5-.3 1.1-.5 1.7 0 .1-.1.2-.1.4-.1.2-.1.5-.2.7 0 .07-.03.13-.1.2 0 .2-.1.3-.1.5 0 .1 0 .2-.1.3v.1c-.1.4-.2.7-.3 1.1 0 .1-.1.2-.1.3-.1.3-.2.7-.3 1 0 .1-.1.2-.1.4-.1.4-.3.9-.5 1.3-.6 1.6-1.2 3.2-1.9 4.7-9.6 22.5-28.1 40.3-51 49.1l-2.4.9c-.5.2-.9.3-1.3.5l-2.7.9c-.5.1-.9.3-1.4.4-.5.1-.9.3-1.4.4-.5.1-.9.2-1.4.3-.6.1-1.1.3-1.7.4-.6.1-1.1.2-1.7.4-5.9 1.2-12 1.8-18.2 1.8s-12.3-.6-18.2-1.8c-.6-.1-1.2-.2-1.8-.4h-.1c-1-.2-2-.5-3-.8s-2-.5-2.9-.8c-3.5-1-6.9-2.3-10.2-3.8-23.1-10.2-41.2-29.7-49.4-53.8-.2-.5-.3-1-.5-1.4-.1-.5-.3-.9-.4-1.3l-.9-3c-.1-.5-.3-1.1-.4-1.6l-.2-.7c-.1-.2-.1-.5-.2-.7-.1-.6-.3-1.2-.4-1.8-1.2-5.9-1.8-12-1.8-18.2s.6-12.3 1.8-18.2l.4-1.7c.4-1.7.8-3.3 1.3-5 .1-.4.2-.9.4-1.3.1-.4.3-.9.4-1.3.1-.4.3-.9.4-1.3.2-.4.3-.9.5-1.3 8.3-23.5 26.1-42.5 48.8-52.5 1.5-.7 3-1.3 4.6-1.9.9-.3 1.7-.6 2.6-.9 1.1-.4 2.1-.7 3.2-1 .5-.2 1.1-.3 1.6-.5s1.1-.3 1.7-.4c.5-.1 1.1-.3 1.7-.4.4-.1.9-.2 1.3-.3.3-.1.5-.1.8-.2.4-.1.8-.2 1.1-.2l1.8-.3c.6-.1 1.1-.2 1.7-.3h.3c.3-.1.7-.1 1-.2h.2c.4-.1.8-.1 1.2-.2.1 0 .3 0 .4-.1.5-.1 1.1-.1 1.6-.2.6-.1 1.2-.1 1.9-.2.4 0 .8-.1 1.2-.1.5 0 1-.1 1.5-.1h.4c.7 0 1.5-.1 2.2-.1h4.6c.7 0 1.5.1 2.2.1h.4c.5 0 1 0 1.5.1.4 0 .8.1 1.2.1.6.1 1.2.1 1.9.2.5.1 1.1.1 1.6.2.1 0 .3 0 .4.1.4 0 .8.1 1.2.2h.2c.3 0 .7.1 1 .2h.3c.6.1 1.1.2 1.7.3s1.1.2 1.7.3 1.2.2 1.7.4c.5.1 1.1.2 1.6.4h.1c.5.1 1.1.3 1.6.4l3.3.9c.5.2 1.1.3 1.6.5h.2c.5.2 1 .3 1.6.5.8.3 1.5.5 2.2.8s1.5.6 2.2.9 1.5.6 2.2.9 1.4.6 2.2 1c.7.3 1.4.7 2.1 1 1.2.6 2.3 1.2 3.5 1.9.6.3 1.1.6 1.7 1 15.9 9.3 28.7 23.4 36.5 40.2.3.6.6 1.2.8 1.8.2.5.5 1 .7 1.6.3.8.7 1.6 1 2.4l.9 2.4c.2.6.4 1.1.5 1.6.2.5.4 1.1.5 1.7.2.6.3 1.1.5 1.7l.9 3.3v.1l.3 1.5v.2c.1.3.1.5.2.8s.1.5.2.8c.1.6.2 1.2.3 1.7.1.6.2 1.1.3 1.6v.3c.1.4.1.7.2 1v.2c.1.4.1.8.2 1.2 0 .1 0 .3.1.4.1.5.1 1.1.2 1.6.1.6.1 1.2.2 1.9 0 .4.1.8.1 1.2v.1c0 .5.1 1 .1 1.5v.4c0 .7.1 1.5.1 2.2v4.6c.2.6.2 1.3.2 2Z"
          style={{
            fill: "#b1b3b9",
            strokeWidth: 0,
          }}
        /> 
      }
      <path
        d="M102.1 157.07c-4.22 0-7.78-1.46-10.69-4.37-2.91-2.91-4.37-6.48-4.37-10.69s1.46-7.78 4.37-10.69c2.91-2.91 6.48-4.37 10.69-4.37s7.78 1.46 10.69 4.37c2.91 2.91 4.37 6.48 4.37 10.69s-1.46 7.78-4.37 10.69c-2.91 2.91-6.48 4.37-10.69 4.37Zm-34.04-34.04-12.65-12.95c5.92-5.92 12.88-10.62 20.86-14.08 7.98-3.46 16.59-5.2 25.83-5.2 9.24 0 17.85 1.76 25.83 5.27 7.98 3.51 14.94 8.28 20.86 14.31l-12.65 12.65c-4.42-4.42-9.54-7.88-15.36-10.39-5.82-2.51-12.05-3.77-18.68-3.77s-12.85 1.26-18.68 3.77c-5.82 2.51-10.94 5.97-15.36 10.39Zm-25.6-25.6L29.81 84.78c9.24-9.44 20.03-16.82 32.38-22.14 12.35-5.32 25.65-7.98 39.91-7.98s27.56 2.66 39.91 7.98c12.35 5.32 23.14 12.7 32.38 22.14l-12.65 12.65c-7.73-7.73-16.69-13.78-26.89-18.15-10.19-4.37-21.11-6.55-32.75-6.55-11.65 0-22.57 2.18-32.76 6.55-10.19 4.37-19.15 10.42-26.88 18.15Z"
        style={{
          fill: contentFill,
          strokeWidth: 0,
        }}
      />
    </g>
  </svg>
);
export default SvgWifi;
